import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface User {
    email: string;
    name: string;
}

interface LikedUserListModalProps {
    likes: User[];
    onClose: () => void;
}

const _LikedUserListModal: React.FC<LikedUserListModalProps> = ({ likes, onClose }) => {
    const { t } = useTranslation();

    return (
        <Modal show onHide={onClose} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>{t('app.liked_users')} {likes?.length}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ul className="liked-user-list py-2">
                    {Array.isArray(likes) && likes?.map((user, index) => (
                        <li key={index} className="d-flex justify-content-start gap-2 align-items-center mt-2 fs-5">
                            <i className="fa-solid fa-circle"></i>
                            {user.name || user.email}
                        </li>
                    ))}
                </ul>
            </Modal.Body>
        </Modal>
    );
};

export default _LikedUserListModal;
